import React, { useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './UploadOrganizationView.css'

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Divider, Button, Input } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const UploadOrganizationView = () => {

    const [fileCharged, setFileCharged] = useState(false)
    const [selectedFile, setSelectedFile] = useState("")
    const [newUserName, setNewUserName] = useState(null)
    const [newPassword, setNewPassword] = useState(null)
    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState("")

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText("Cargando información y creando la organización. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_username", newUserName);
        formData.append("org_password", newPassword);

        const token = localStorage.getItem('access_token');
        
        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        }

        axios
            .post(`${apiUrl}/files/upload-organization/`, formData, headers)
            .then(function (response) {
                // getUploadedFiles();
                resetStates();
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
        setNewUserName(null)
        setNewPassword(null)
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer'>
            {/* <SideMenuAdmin /> */}
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Administración de organizaciones</Title>
                    <Paragraph>
                        Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                        <ol style={{ marginTop: 10, marginBottom: 10 }}>
                            <li>Llena el formulario para asignar nombre de usuario y contraseña al adminsitrador de la organización</li>
                            <li>Da click en el cargador o arrastra tu archivo a la zona de carga del archivo</li>
                            <li>Da click en el botón "Crear organización"</li>
                        </ol>
                    </Paragraph>
                </Typography>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        <div className='display-center-row display-center-column align-full-center uploader-container fileinfo-container' >
                            <div className='display-center-row display-center-column'>
                                <span>Nombre de usuario</span>
                                <Input value={newUserName} style={{ width: 'auto', marginTop: 10 }} onChange={(ele) => setNewUserName(ele.target.value)} />
                            </div>
                            <div style={{ marginTop: 20 }} className='display-center-row display-center-column'>
                                <span>Contraseña</span>
                                <Input value={newPassword} style={{ width: 'auto', marginTop: 10 }} onChange={(ele) => setNewPassword(ele.target.value)} />
                            </div>
                        </div>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto', marginTop: "20px" }} type="primary" onClick={uploadFile} disabled={!newUserName || !newPassword || !fileCharged}>Crear organización</Button>
                </div>
                <Divider />
            </div>
        </Content>
    </div>
}

export default UploadOrganizationView;